import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import './Sidebar.css';

const Sidebar = () => {
  const { user } = useAuth();
  
  // Get first letter of user name or display fallback
  const getUserInitial = () => {
    if (user && user.displayName) {
      return user.displayName.charAt(0).toUpperCase();
    } else if (user && user.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return "U";
  };
  
  // Get display name or fallback to email/guest
  const getDisplayName = () => {
    if (user && user.displayName) {
      return user.displayName;
    } else if (user && user.email) {
      return user.email.split('@')[0]; // Use portion before @ in email
    }
    return "Guest";
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-user">
        <div className="user-avatar">
          {user && getUserInitial()}
        </div>
        <div className="user-info">
          <h3>{user && getDisplayName()}</h3>
          <p>{user && user.email}</p>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <ul>
          <li>
            <NavLink to="/dashboard" end>
              <i className="fas fa-tachometer-alt"></i> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/links">
              <i className="fas fa-link"></i> Affiliate Links
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/links/create">
              <i className="fas fa-plus-circle"></i> Create Link
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/conversions">
              <i className="fas fa-exchange-alt"></i> Conversions
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/export">
              <i className="fas fa-file-export"></i> Export Data
            </NavLink>
          </li>
          <li className="sidebar-divider"></li>
          <li>
            <NavLink to="/dashboard/subscription">
              <i className="fas fa-crown"></i> Subscription
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/pro-features">
              <i className="fas fa-star"></i> Pro Features
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/invoices">
              <i className="fas fa-file-invoice-dollar"></i> Invoices
            </NavLink>
          </li>
          <li>
            <NavLink to="/dashboard/account">
              <i className="fas fa-user-cog"></i> Account
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
